import { useParams } from "react-router-dom";
import { Bell, Key, KeyRound, MessageSquare, Plug, Send, Settings } from "lucide-react";

import { SidebarLayout } from "../SidebarLayout";

export const SettingsSection = () => {
  const { projectId } = useParams();
  return (
    <>
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/settings`}
        label="Project settings"
        iconSvg={<Settings size={20} />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/api-keys`}
        label="API keys"
        iconSvg={<Key size={20} />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/jwt-keys`}
        label="JWT keys"
        iconSvg={<KeyRound size={20} />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/provider-apps`}
        label="Provider apps"
        iconSvg={<Plug size={20} />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/destinations`}
        label="Destinations"
        iconSvg={<Send size={20} />}
      />
      {import.meta.env.VITE_ALPHA_MODE === 'true' && (
        <SidebarLayout.SidebarMainLayout.ListNavLink
          to={`/projects/${projectId}/topics`}
          label="Topics"
          iconSvg={<MessageSquare size={20} />}
        />
      )}
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/notifications`}
        label="Notifications"
        iconSvg={<Bell size={20} />}
      />
    </>
  );
};

